let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("li9sm"), load("hhss7"), load("gmwfN")]).then(() => parcelRequire('53kS0'));